function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const reporters = new Map();
export function initReports(id, config) {
    return _initReports.apply(this, arguments);
}
function _initReports() {
    _initReports = _async_to_generator(function*(id, config) {
        if (reporters.has(id)) {
            return;
        }
        const ReportsServerPromise = import('../../internal/errors/utils/ReportsServer');
        reporters.set(id, ReportsServerPromise.then(({ default: ReportsServer })=>new ReportsServer(config)));
    });
    return _initReports.apply(this, arguments);
}
export function report(method, id, error, scope) {
    return _report.apply(this, arguments);
}
function _report() {
    _report = _async_to_generator(function*(method, id, error, scope) {
        const server = yield reporters.get(id);
        server === null || server === void 0 ? void 0 : server[method](error, scope);
    });
    return _report.apply(this, arguments);
}

//# sourceMappingURL=reports.server.js.map